import type { QueryKey } from '@tanstack/react-query';
import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import { apiClient } from 'lib/api';

export type Statuses = 'Failed' | 'Success';
export type StatusesParam = 'failed' | 'success';

interface StatusEntry {
  id: StatusesParam;
  name: Statuses;
}

export const getStatuses = async (signal?: AbortSignal): Promise<StatusEntry[]> => {
  const res = await apiClient.get<StatusEntry[]>(queryKeys.statuses, {
    signal,
  });

  return res.data;
};

interface UseStatusesListOptions<TData> {
  config?: QueryConfig<typeof getStatuses, TData>;
}

export const useStatuses = <TData = StatusEntry[]>({ config }: UseStatusesListOptions<TData>) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getStatuses(signal),
    queryKey: [queryKeys.statuses] as QueryKey,
  });
};
